<template>
  <div class="bg d-flex align-items-center justify-content-center">
    <div class="login d-flex flex-wrap flex-md-nowrap align-items-center justify-content-center">
        <div class="left">
<!--          <img src="../assets/images/login-bg.png" class="logos" alt="">-->
          <img :src="logoImage" class="logos" alt="">
          <p class="text-white  mt-5 font-white fw-bold login-title">{{title}}</p>
          <p class="text-white mt-4 font-white fw-bold login-title">“明石杯”微纳传感技术与智能应用赛</p>
        </div>
        <div class="right d-flex align-items-center justify-content-center">
          <el-card class="card" shadow="hover" >
            <template v-slot:header >
              <text class="fw-bold">
                用户登录
              </text>
            </template>
            <el-form hide-required-asterisk :model="form" size="large" label-width="auto" style="width: 100%" ref="ruleFormRef" :rules="rules" >
              <el-form-item label="账号：" prop="account" >
                <el-input v-model="form.account" placeholder="请输入手机号/用户名"/>
              </el-form-item>
              <el-form-item label="密码：" type="password" prop="password" autocomplete="off">
                <el-input type="password" v-model="form.password" placeholder="请输入密码"/>
<!--                <el-input-->
<!--                    v-model="form.password"-->
<!--                    type="password"-->
<!--                    placeholder="请输入"-->
<!--                    show-password-->
<!--                />-->
              </el-form-item>
              <el-form-item label="验证码：" prop="captcha">
                <div class="d-flex align-items-center justify-content-between w-100 " >
                  <el-input v-model="form.captcha" class="me-2"  placeholder="请输入验证码"/>
                  <div class="position-relative flex-column code flex-shrink-0" @click="getCaptchaFun" v-loading="getCodeLoading">
                    <img :src="base64" alt="点击获取" class="border-1 border point-curser code-img " >
                    <!--                    <a class="small text-primary point-curser mt-2 position-absolute reload-base" @click="getCaptchaFun">-->
                    <!--                      看不清？-->
                    <!--                    </a>-->
                  </div>
                </div>
              </el-form-item>
              <div class="w-100 px-3 d-flex align-items-center justify-content-center flex-column mt-4">
                <el-button type="primary" class="btn-save w-100"
                           :loading="loading"
                           :disabled="!(form.account &&form.account.trim() && form.password&&form.password.trim() && form.captcha&&form.captcha.trim())"
                           @click="login"
                >登录</el-button>
<!--                :class="can_register?'justify-content-between':'justify-content-center'"-->
                <div class="py-2 d-flex align-items-center  w-100 justify-content-between"  >
                  <el-button type="" text @click="goChangePsw">找回密码</el-button>
                  <el-button type="primary"  text @click="goRegister">立即注册</el-button>
                </div>
                <div class="small text-secondary" v-if="!can_register">开放注册时间</div>
                <div class="small text-secondary" v-if="!can_register">{{register_start}} ~ {{register_end}}</div>
                <div class="question"> <a href="https://www.mnmcloud.com/competitionquestion" target="_blank">报名问题在线反馈</a></div>
<!--                <div class="py-2 d-flex align-items-center justify-content-center w-100">-->
<!--                  <el-button type="" text @click="goChangePsw">找回密码</el-button>-->
<!--                  <el-button type="primary" v-if="can_register" text @click="goRegister">立即注册</el-button>-->
<!--                </div>-->
              </div>
            </el-form>
          </el-card>
        </div>
    </div>

  </div>
  <FindPassWordModel v-if="showFindPassword" @success="pwChangeSuccess" @close="PWChangeClose"></FindPassWordModel>

</template>

<script setup>
import {reactive, onMounted, ref, computed} from 'vue'
import {accountLogin, getCaptcha} from "@/api/login";
import {ElMessage, ElMessageBox} from "element-plus";
import {setToken} from "@/utils/token";
import router from "@/router";
import FindPassWordModel from "@/components/FindPassWordModel"
const showFindPassword = ref(false)
import {useStore} from 'vuex'
import {removeMember} from "@/api/student";
const store = useStore()
const form = reactive({
  account:"",
  password:null,
  captcha:null,
})
const logoImage = computed(()=>store.state.sysModel.logo)
const title = computed(()=>store.state.sysModel.title)
const can_register = computed(()=>store.state.sysModel.can_register)
const register_start = computed(()=>store.state.sysModel.register_start)
const register_end = computed(()=>store.state.sysModel.register_end)
const rules = ({
  account: [ { required: true, message: '请输入账号',trigger:['change','blur'] }],
  password: [{ required: true, message: '请输入密码',trigger:['change','blur'] }],
  captcha: [{ required: true, message: '请输入验证码',trigger:['change','blur'] }],
})
const getCodeLoading = ref(true)
const loading = ref(false)
const base64 = ref('')
let captchaId = null // 当前验证码的id

onMounted(()=>{
  getCaptchaFun()
  store.dispatch("sysModel/getAllsettingsFun") // 获取系统配置
})
// 获取验证码
const getCaptchaFun = async ()=>{
  getCodeLoading.value = true
  const res = await getCaptcha()
  getCodeLoading.value = false
  if(res.err_code==0){
    captchaId = res.data.captchaId
    base64.value = res.data.image
  }else{
    captchaId = ""
    base64.value = ""
    ElMessage.warning("获取验证码失败！")
  }
}
const login =async ()=>{
  const params = {...form,captchaId:captchaId}
  loading.value = true
  const res = await accountLogin(params)
  loading.value = false
  if(res.err_code === 0){
    setToken(res.data)// 保存token
    store.commit("loginModel/login", true) // 修改state
    ElMessage.success("登录成功！")
    loading.value = true
    await store.dispatch("loginModel/getUserInfo") //获取用户信息
    loading.value = false
    window.location.reload() // 重新加载页面
  }else{
    ElMessage.warning(res.err_msg || "账号或密码错误")
    getCaptchaFun() // 重新获取验证码
  }
}

// 去注册
const goRegister = ()=>{
  if(!can_register.value){
    // return   ElMessageBox.alert(`<h1>当前时间段无法进行注册，请留意注册时间\n。</h1><h1>开放注册时间为：${register_start.value} ~ ${register_end.value}</h1>> `, '提示', {
    //   confirmButtonText: '已知晓',
    //   callback: (action) => {
    //     if(action==='confirm'){ // 确定
    //     }
    //   },
    // })
   return ElMessageBox.alert(
        `<div>当前时间段无法进行注册,开放注册时间为：</div><div style="color:red">${register_start.value} ~ ${register_end.value}</div>`,
        '提示',
        {
          confirmButtonText: '已知晓',
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            if(action==='confirm'){ // 确定
            }
          },
        }
    )
  }
  router.push({path:"/register"})
}
const goChangePsw = ()=>{
  // if(!can_register.value){
  //   return   ElMessageBox.alert('当前时间段无法修改密码', '提示', {
  //     confirmButtonText: '已知晓',
  //     callback: (action) => {
  //       if(action==='confirm'){ // 确定
  //       }
  //     },
  //   })
  // }
  showFindPassword.value = true
}
// 修改密码成功
const pwChangeSuccess = (data)=>{
  showFindPassword.value = false
  form.account = data.Tel
  form.password = data.Password
}

const PWChangeClose = ()=>{
  showFindPassword.value = false
}



</script>

<style scoped lang="scss">
.bg{
  width: 100%;
  height: 100%;
  background-image: url("https://cdn.brightstonecloud.com/competition/doc/login2_1740551373.jpg");
  background-size: cover;
  justify-content: center;
}
.login{
  width: 100%;
 max-width: 1200px;
  height: 100%;
  display: flex;


  //flex-wrap: wrap;
}
.left{
  width: 100%;
  min-width: 400px;
}
.logos{
  width: 80%;
  height: auto;

}
.login-title{
  font-size: 2rem;
}
.right{
  width: 100%;
  height: 400px;
  .card{
    width: 80%;
    max-width: 400px;
  }
}

.bg-img{
  width: 100vw;
  height: 100vh;
  position: absolute;
  object-fit: cover;
  left: 0;
}
.code{
  width:80px;
  height:38px;
  overflow: hidden;
  .code-img{
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}
.btn-save{
  width: 100%;
  height: 40px;
}
.el-card__header{
  background: #0d6efd !important;
}
.reload-base{
  bottom: -28px ;
  left: 10px;
}
.question{
  //position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 10px 0;
  //color: white;
  font-weight: bold;
  font-size: 14px;
  color: #3f9dfd;
  text-decoration: solid;
  cursor: pointer;
}
</style>
